import musicFile from "../../assets/voices/roulette-double.mp4";

// Singleton Audio: criado uma vez e compartilhado entre o botão de Jogar
// (que destrava o áudio no clique) e a Roulette (que toca depois via socket).
export const rouletteMusic = new Audio(musicFile);
rouletteMusic.loop = true;
rouletteMusic.preload = "auto";

let unlocked = false;

// Chamado no clique de Jogar. Mobile (iOS Safari / Chrome Android) só
// libera audio.play() se for disparado dentro de um gesto do usuário;
// tocamos e pausamos imediatamente para registrar a permissão no browser,
// pra o play automático via socket (match_found) funcionar depois.
export function unlockRouletteMusic() {
  if (unlocked) return;
  const playPromise = rouletteMusic.play();
  if (playPromise !== undefined) {
    playPromise
      .then(() => {
        rouletteMusic.pause();
        rouletteMusic.currentTime = 0;
        unlocked = true;
      })
      .catch(() => {
        // Browser bloqueou mesmo assim; próximo clique tenta de novo.
      });
  }
}
